export const WalletTypeConst = {
  DEPOSIT: "deposit",
  WITHDRAW: "withdraw",
  TRANSFER: "transfer",
  PROGRESS: "progress",
};
